import React, { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import { LineChart } from "@mui/x-charts";
import { getProductCostHistory } from "../../api/products";

interface ProductCostPlotProps {
  props: {
    id: string;
  };
}

const ProductCostPlot: React.FC<ProductCostPlotProps> = ({ props }) => {
  const { id } = props;
  const [loading, setLoading] = useState(true);
  const [dates, setDates] = useState<Date[]>([]);
  const [costs, setCosts] = useState<number[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getProductCostHistory(id);
        const result = response.data;
        const costData = result.map((item) => item.price);
        const dateData = result.map((item) => new Date(item.timestamp));
        
        setCosts(costData);
        setDates(dateData);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" p={3}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box p={2} sx={{ width: "100%", height: 400 }}>
      <LineChart
        xAxis={[
          {
            data: dates,
            scaleType: "time",
            label: "Fecha",
          },
        ]}
        yAxis={[
          {
            label: "Costo",
            valueFormatter: (value) =>
              new Intl.NumberFormat("es-MX", {
                style: "currency",
                currency: "MXN",
              }).format(value),
          },
        ]}
        series={[
          {
            data: costs,
            label: "Costo Histórico",
            area: true,
            showMark: true,
          },
        ]}
        margin={{ top: 20, right: 20, bottom: 50, left: 80 }}
      />
    </Box>
  );
};

export default ProductCostPlot; 